import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import "react-dropzone-uploader/dist/styles.css";
import Dropzone from "react-dropzone-uploader";
import { uploadFile } from "../../utils/fetcher";
import { useDispatch } from "react-redux";

export default function UploadFileQuestion() {
  const [openDialog, setOpenDialog] = React.useState(true);
  const dispatch = useDispatch();

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const getUploadParams = () => {
    return { url: "https://httpbin.org/post" };
  };
  const handleSubmit = files => {
    dispatch(uploadFile(files));
    //allFiles.forEach(f => f.remove());
  };

  return (
    <Dialog
      onClose={handleCloseDialog}
      aria-labelledby="customized-dialog-title"
      open={openDialog}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleCloseDialog}>
        Modal title
      </DialogTitle>
      <DialogContent dividers>
        <div className="bloc-dropzone">
          <Dropzone
            maxSizeBytes={10 * 1e6}
            getUploadParams={getUploadParams}
            onSubmit={handleSubmit}
            maxFiles={1}
            submitButtonContent="Envoyer"
            inputWithFilesContent="Ajouter fichiers"
            inputContent="Faites glisser et déposez votre fichier ici,ou cliquez pour sélectionner votre fichier"
            styles={{
              dropzone: { width: 520 },
              dropzoneActive: { borderColor: "green" }
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
